import { FC } from "react";
import { Spin } from "antd";

export const PatientTimelineLoading: FC = () => {
  return <Spin />;
};
